function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "03-google map",
    id: "_03-google_map"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 19,
    r: 6,
    style: {
      fill: "#a83229"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41 63 7 63 24 46 41 63",
    style: {
      fill: "#4a9bf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,7V57a6,6,0,0,1-6,6H53L30,40l7.61-7.61A102.883,102.883,0,0,0,45,41S59,26.73,59,19a13.921,13.921,0,0,0-1.57-6.43Z",
    style: {
      fill: "#d3d9f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,7l-5.57,5.57a13.908,13.908,0,0,0-6-6L57,1A6,6,0,0,1,63,7Z",
    style: {
      fill: "#ffdf64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53 63 41 63 24 46 30 40 53 63",
    style: {
      fill: "#f7f7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.61,32.39,30,40l-6,6L7,63a6,6,0,0,1-6-6L32.89,25.11A50.652,50.652,0,0,0,37.61,32.39Z",
    style: {
      fill: "#ffdf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,1,51.43,6.57A13.991,13.991,0,0,0,31,19a14.149,14.149,0,0,0,1.89,6.11L1,57V7A6,6,0,0,1,7,1Z",
    style: {
      fill: "#28be77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.43,12.57A13.921,13.921,0,0,1,59,19c0,7.73-14,22-14,22a102.883,102.883,0,0,1-7.39-8.61,50.652,50.652,0,0,1-4.72-7.28A14.149,14.149,0,0,1,31,19a14,14,0,0,1,26.43-6.43ZM51,19a6,6,0,1,0-6,6A6,6,0,0,0,51,19Z",
    style: {
      fill: "#d73d3f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11 59 7 63 41 63 37 59 11 59",
    style: {
      fill: "#3b7cc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,59H49l4,4h4a6,6,0,0,0,6-6V53A6,6,0,0,1,57,59Z",
    style: {
      fill: "#aeb2d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.117,7.883A5.945,5.945,0,0,1,63,11V7Z",
    style: {
      fill: "#b8bce0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,5a5.992,5.992,0,0,1,5.117,2.883L63,7a6,6,0,0,0-6-6L53,5Z",
    style: {
      fill: "#ffb844"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37 59 41 63 53 63 49 59 37 59",
    style: {
      fill: "#cacfe8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,59a5.992,5.992,0,0,1-5.117-2.883L1,57a6,6,0,0,0,6,6l4-4Z",
    style: {
      fill: "#ffb844"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,53v4l.883-.883A5.945,5.945,0,0,1,1,53Z",
    style: {
      fill: "#1fa463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,5H53l4-4H7A6,6,0,0,0,1,7v4A6,6,0,0,1,7,5Z",
    style: {
      fill: "#1fa463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,22A9,9,0,1,1,20.025,7.375L16.9,9.875A5,5,0,1,0,17.583,15H13V11h7a2,2,0,0,1,2,2A9.011,9.011,0,0,1,13,22Z",
    style: {
      fill: "#f7f7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,17a6,6,0,0,1,5.65,4,6,6,0,1,0-11.3,0A6,6,0,0,1,45,17Z",
    style: {
      fill: "#91323c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2,20.71A14.048,14.048,0,0,0,31,23a10.248,10.248,0,0,0,.668,3.332L32.89,25.11A17.958,17.958,0,0,1,31.2,20.71Z",
    style: {
      fill: "#1fa463"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.793,20.735C57.082,28.681,45,41,45,41a102.883,102.883,0,0,1-7.39-8.61l-1.68,1.68c.549.787,1.108,1.566,1.68,2.32A102.883,102.883,0,0,0,45,45S59,30.73,59,23A13.843,13.843,0,0,0,58.793,20.735Z",
    style: {
      fill: "#aeb2d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.89,25.11l-1.222,1.222A21.63,21.63,0,0,0,32.89,29.11a43.491,43.491,0,0,0,3.04,4.96l1.68-1.68A50.652,50.652,0,0,1,32.89,25.11Z",
    style: {
      fill: "#ffb844"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMap);
export default __webpack_public_path__ + "static/media/google_map.e50c69d92f6347fb02ed8566ef39566f.svg";
export { ForwardRef as ReactComponent };